import { instance } from "./axios";

const ClientService = {
  get(params = {}) {
    return instance
      .get("/api/client", {
        params: params
      })
      .then(response => response.data)
      .catch(e => {
        return { success: false, message: e };
      });
  },
  getPayslip(params = {}) {
    return instance
      .get("/api/client/payslips/{month}", {
        params: params
      })
      .then(response => response.data)
      .catch(e => {
        return { success: false, message: e };
      });
  },
  getQrCode(params = {}) {
    return instance
      .get("/api/client/qrcode", {
        params: params
      })
      .then(response => response.data)
      .catch(e => {
        return { success: false, message: e };
      });
  },
  impersonate(data) {
    return instance
      .post("/api/client/impersonate", data)
      .then(response => response.data)
      .catch(e => {
        return { success: false, message: e };
      });
  },
  // ← Nouvelle méthode pour l’envoi des feedbacks
  sendFeedback(data) {
    return instance
      .post("/api/client/service-projects/feedback", data)
      .then(response => response.data)
      .catch(e => ({ success: false, message: e }));
  }
};

export default ClientService;
